// Customer-ready quote text (clipboard). Customer-facing only: no vehicle
// classes, no internal notes or pricing rules. Prices CAD, GST per rate.

export const fmt2 = (n) => `$${Number(n || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Clipboard write with fallback for restricted contexts (older Safari/iPad,
// automation) — never throws uncaught.
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      ta.remove();
      return ok;
    } catch {
      return false;
    }
  }
}

export function buildQuoteText({
  vehicleLabel,
  lines,                 // [{label, amount, note?}]
  subtotal,
  discount = 0,          // order-level discount ($ off, shown before subtotal math)
  taxRate = 5,
  tax,
  total,
  paid = null,           // invoice: amount already paid (payments unchanged)
  balance = null,
  fullVehiclePreliminary = false,
}) {
  const out = ["WTD Detailing & Tint"];
  if (vehicleLabel) out.push(`Vehicle: ${vehicleLabel}`);
  out.push("");
  for (const l of lines) {
    out.push(`${l.label} — ${fmt2(l.amount)}${l.note ? ` (${l.note})` : ""}`);
  }
  out.push("");
  if (discount > 0) out.push(`Discount: −${fmt2(discount)}`);
  out.push(`Subtotal: ${fmt2(subtotal)}`);
  out.push(`GST (${taxRate}%): ${fmt2(tax)}`);  out.push(`Total: ${fmt2(total)} CAD`);
  if (paid != null && paid > 0) {
    out.push(`Paid to date: ${fmt2(paid)}`);
    out.push(`Balance due: ${fmt2(balance)}`);
  }
  out.push("");
  out.push("All prices in Canadian dollars.");
  if (fullVehiclePreliminary) {
    out.push("");
    out.push("Full Vehicle PPF — preliminary estimate only. Final pricing will be confirmed after a free vehicle inspection.");
  }
  return out.join("\n");
}
